export const appVersion = "1.64.0-11268";
